export const COUPON_VALIDATE_REQUEST = "COUPON_VALIDATE_REQUEST";
export const COUPON_VALIDATE_SUCCESS = "COUPON_VALIDATE_SUCCESS";
export const COUPON_VALIDATE_FAIL = "COUPON_VALIDATE_FAIL";
export const COUPON_CLEAR = "COUPON_CLEAR";
